export default __webpack_public_path__ + "static/media/img-danger.56e64287.svg";